import { Config } from "../.env.js";
export const signup = async ({
  yourName,
  email,
  phone,
  password,
  otp,
  brandName,
  consents,
}) => {
  const user = { yourName, email, phone, password, otp, brandName, consents };

  try {
    const res = await fetch(`${Config.API_URL}/signup`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(user),
    });
    return await res.json();
  } catch (err) {
    throw new Error(`cannot register at this time . ${err}`);
  }
};

// admin sugnin
export const login = async ({ email, password, brandName, role } = {}) => {
  const user = { email, password, brandName, role };

  try {
    const res = await fetch(`${Config.API_URL}/login`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(user),
    });
    return await res.json();
  } catch (err) {
    throw new Error(`Cannot login at this time. ${err}`);
  }
};

export const sharedLogin = async ({ email, password, loginType } = {}) => {
  const user = { email, password, loginType };

  try {
    const res = await fetch(`${Config.API_URL}/shared-login`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(user),
    });

    return await res.json();
  } catch (err) {
    throw new Error(`Cannot login at this time. ${err}`);
  }
};
export const requestLoginOtp = async ({ email } = {}) => {
  try {
    const res = await fetch(`${Config.API_URL}/request-login-otp`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    return await res.json();
  } catch (err) {
    throw new Error(`Cannot send OTP at this time. ${err}`);
  }
};

export const verifyLoginOtp = async ({ email, otp, loginType } = {}) => {
  try {
    const res = await fetch(`${Config.API_URL}/verify-login-otp`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, otp, loginType }),
    });

    return await res.json();
  } catch (err) {
    throw new Error(`Cannot verify OTP at this time. ${err}`);
  }
};

export const signIn = async ({ email, password, brandName } = {}) => {
  const user = { email, password, brandName };

  try {
    const res = await fetch(`${Config.API_URL}/signIn`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(user),
    });
    return await res.json();
  } catch (err) {
    throw new Error(`Cannot login at this time. ${err}`);
  }
};

// Influencer Signup
export const influencerSignup = async ({
  role,
  FullName,
  Email,
  MobileNumber,
  password,
  OTP,
  consents,
}) => {
  const user = { role, FullName, Email, MobileNumber, password, OTP, consents };

  try {
    const res = await fetch(
      `${Config.API_URL}/api/influencer/influencer-signup`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
      }
    );
    return await res.json();
  } catch (err) {
    throw new Error(`cannot register at this time . ${err}`);
  }
};

// Influencer Login
export const influencerLogin = async ({ email, password, role } = {}) => {
  const user = { email, password, role };

  try {
    const res = await fetch(
      `${Config.API_URL}/api/influencer/influencer-login`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
      }
    );
    return await res.json();
  } catch (err) {
    throw new Error(`Cannot login at this time. ${err}`);
  }
};
